<template>
    <div style=" background-color: #ffffff;">
        <div class="flexBox">
            <el-form class="demo-form-inline" :inline="true" ref="wmsWarehouseForm" :model="wmsWarehouseForm" size="mini" label-width="120px">
                <el-form-item label="任务类型" prop="taskType"> 
                    <el-select placeholder="请选择任务类型" v-model="wmsWarehouseForm.taskType">
                        <el-option v-for="item in taskTypeList" :key="item.value" :label="item.value" :value="item.value"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="任务状态" prop="billStatus"> 
                    <el-select placeholder="请选择任务状态" v-model="wmsWarehouseForm.billStatus" clearable>
                        <el-option v-for="item in billStatusTypeList" :key="item.value" :label="item.value" :value="item.value"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="作业状态" prop="taskStatus"> 
                    <el-select placeholder="请选择作业状态" v-model="wmsWarehouseForm.taskStatus" clearable>
                        <el-option v-for="item in creationTypeList" :key="item.value" :label="item.value" :value="item.value"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="账册编号" prop="handbook"> 
                    <el-select placeholder="请选择账册编号" v-model="wmsWarehouseForm.handbook" clearable>
                        <el-option v-for="item in handBookNoList" :key="item.bookNo" :label="item.bookNo" :value="item.bookNo"> </el-option>
                    </el-select>
                </el-form-item>
                
                <el-form-item label="仓库名称" prop="ckName"> 
                    <el-select placeholder="请选择仓库" v-model="wmsWarehouseForm.ckName" clearable>
                        <el-option v-for="item in ckNameList" :key="item" :label="item" :value="item"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="委托单位" prop="customer"> 
                    <el-select filterable placeholder="请选择委托单位" v-model="wmsWarehouseForm.customer" clearable>
                        <el-option v-for="item in customerList" :key="item.id" :label="item.companyName" :value="item.companyName"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="货主" prop="ownerName"> 
                    <el-select filterable placeholder="请选择货主" v-model="wmsWarehouseForm.ownerName" clearable>
                        <el-option v-for="item in customerList" :key="item.id" :label="item.companyName" :value="item.companyName"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="任务单号" prop="billNo"> 
                    <el-input placeholder="请输入任务单号" clearable v-model="wmsWarehouseForm.billNo" suffix-icon="xxxx" ></el-input>
                </el-form-item>
                <el-form-item label="提单号" prop="blNo"> 
                    <el-input placeholder="请输入提单号" clearable v-model="wmsWarehouseForm.blNo" suffix-icon="xxxx" ></el-input>
                </el-form-item>
                <el-form-item label="保税类型" prop="isBonded"> 
                    <el-select placeholder="请选择保税类型" v-model="wmsWarehouseForm.isBonded" clearable>
                        <el-option v-for="item in bondedTypeList" :key="item.value" :label="item.value" :value="item.value"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="报关单号" prop="cusDeclNo"> 
                    <el-input placeholder="请输入报关单号" clearable v-model="wmsWarehouseForm.cusDeclNo" suffix-icon="xxxx" ></el-input>
                </el-form-item>
                <el-form-item label="核注清单号" prop="invDecNo"> 
                    <el-input placeholder="请输入核注清单号" clearable v-model="wmsWarehouseForm.invDecNo" suffix-icon="xxxx" ></el-input>
                </el-form-item>
                <el-form-item label="箱号" prop="boxNo"> 
                    <el-input placeholder="请输入箱号" clearable v-model="wmsWarehouseForm.boxNo" suffix-icon="xxxx" ></el-input>
                </el-form-item>
                <el-form-item label="车号" prop="truckNo"> 
                    <el-select class="width_100" v-model="wmsWarehouseForm.truckNo" placeholder="请选择或输入车牌" filterable remote @focus="driverTruckNoList=[]"
                    :remote-method="truckNoRemoteMethod" @blur="selectTruckNo" :default-first-option="true" clearable>
                        <el-option v-for="item in driverTruckNoList" :key="item.id" :label="item.carNo" :value="item.carNo" />
                    </el-select>
                </el-form-item>
                <el-form-item label="创建日期" prop="createDate"> 
                    <el-date-picker v-model="wmsWarehouseForm.createDate" clearable value-format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                    @change="getCreateDate" > </el-date-picker>
                </el-form-item>
                <el-form-item label="计划作业日期" prop="planDate"> 
                    <el-date-picker v-model="wmsWarehouseForm.planDate" clearable value-format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                    @change="getPlanDate"> </el-date-picker>
                </el-form-item>
                <el-form-item > 
                    <el-button size="mini" @click="taskListSeacher" type="primary" plain>搜索</el-button>
                    <el-button size="mini" @click="clearSeacher"  plain>清空</el-button>
                    <el-button size="mini" @click="nweInWarehouse" plain>新增入库任务单</el-button>
                    <el-button size="mini" @click="nweoutbound" plain>新增出库任务单</el-button>
                </el-form-item>
            </el-form>
            <div >
                <vxe-toolbar ref="toolbarRef" custom> </vxe-toolbar>
            </div>
        </div>
        <div style="height: calc(100vh - 260px);">
            <vxe-table height="auto" :data="taskList" ref="wmsWarehouse" id="wmsWarehouse" size="mini" :columns="columns" :column-config="{ resizable: true }" 
            :custom-config="customConfig"  :row-config="{ isCurrent: true /* 启用当前行高亮 */ }" highlight-current-row  @cell-dblclick="getdetailsDblclick"
            :footer-method="footerMethod" show-footer> 
                <vxe-column type="seq" width="50" align="center"></vxe-column>
                <vxe-column v-for="(column, index) in columns" :field="column.field" :title="column.title" sortable>
                    <template #default="{ row, column }">
                        <span v-if="column.field === 'billNo'" @click="getdetails(row)">
                            <el-link  type="primary">{{row.billNo}}</el-link>
                        </span>
                        <div v-else-if="column.field === 'truckNo'" class="truck-no-cell"> 
                            {{ row[column.field] }}
                        </div>
                        <div v-else-if="column.field === 'boxNo'" class="truck-no-cell"> 
                            {{ row[column.field] }}
                        </div>
                        <div v-else-if="column.field === 'rkBlNo'" class="truck-no-cell"> 
                            {{ row[column.field] }}
                        </div>
                        <span v-else-if="column.field !== 'billNo'"> {{ row[column.field] }} </span>
                    </template>
                </vxe-column>
                <vxe-column title="操作" width="80" align="center" fixed="right" v-if="taskList.length ? (taskList[0].taskType === '入库' ? true : false ):false" >
                    <template #default="{ row }">
                        <el-button type="text" size="mini" class="mini_button" @click="copyInWarehouse(row)">复制</el-button>
                    </template>
                </vxe-column>   
            </vxe-table>
        </div>
        <!-- 171 -->
        <vxe-pager align="left" :current-page.sync="pagination.currentPage" :page-size.sync="pagination.pageSize" :page-sizes="pageSizes"
            :total="pagination.total" @page-change="getTaskList" size="mini">
        </vxe-pager>
    </div>
</template>

<script>
import userProfile from '@/mixins/userProfile.js'
import { jumpInWarehouse, closeAllWarehouseWindows } from '@/config/jumpInWarehouse.js'
export default {
    name: 'inAndOutList',
    mixins: [userProfile],
    components:{
    },
    data() {
        return {
            openedWindows: {},
            jumpUrlId:'',
            taskList:[], // 入库任务单列表
            columns:[], // 列名
            driverTruckNoList:[], // 车号列表
            // 分页信息
            pagination:{
                totalPages: 0, // 总页数
                total: 0, // 总条数
                currentPage: 1, // 当前页数
                pageSize: 10, // 每页显示多少条数据
            },
            pageSizes:[10,15,20,50,100],
            wmsWarehouseForm:{
                ckName: '', // 仓库名称
                handbook: '', // 账册编号
                taskStatus: '', // 任务状态
                createDate:'', // 创建日期
                createDateStart: '', // 创建日期起
                createDateEnd: '', // 创建日期止
                taskType: '入库', // 出入库类型
                ownerName: '', // 货主单位
                billNo: '', // 任务单号
                blNo: '', // 提单号
                customer: '', // 委托单位
                isBonded: '', // 保税类型
                cusDeclNo: '', // 报关单号
                invDecNo: '', // 核注清单号
                planDate:'', // 计划作业日期
                planDateStart: '', // 计划作业日期起
                planDateEnd: '', // 计划作业日期止
                boxNo: '', // 箱号
                truckNo:'', // 车号
                billStatus:'', // 任务状态
            },
            taskTypeList:[
                {
                    value: '入库',
                    label: '入库'
                },{
                    value: '出库',
                    label: '出库'
                }
            ], // 任务类型
            creationTypeList:[
                {
                    value: '新建',
                    label: '新建'
                },{
                    value: '作业中',
                    label: '作业中'
                },{
                    value: '完成',
                    label: '完成'
                }
            ],// 任务状态
            billStatusTypeList:[
                {
                    value: '未结束',
                    label: '未结束'
                },{
                    value: '结束',
                    label: '结束'
                }
            ],
            handBookNoList:[], // 账册编号列表
            ckNameList:[],  // 仓库名称列表
            customerList:[], // 委托单位列表
            bondedTypeList:[], // 保税类型列表
        }
    },
    async created() {
        await this.getckNameList()
        await this.taskListSeacher()
        this.gethandBookNo()
        this.getCompanyList()
        this.getIsBonded()
        this.$eventBus.$on('closeSonWindow', () => {
            this.closeSonWindow()
        });
        window.addEventListener('message', (event) => {
            if (event.data.type === 'WINDOW_CLOSED') {
                localStorage.setItem('openedWindowsBoolean', event.data.value);
            }
        });
    },
    mounted() {
        // 监听页面卸载事件
        window.addEventListener('beforeunload', this.handleBeforeUnload);
    },
    methods: {
        // 清空搜索条件
        clearSeacher(){
            this.$nextTick(()=>{
                this.$refs.wmsWarehouseForm.resetFields();
            })
        },
        // 获取账册编号列表
        gethandBookNo(){
            this.$api.wmsgetHandBook(  ).then(res =>{
                this.handBookNoList = res.tableData
            })
            
        },
        // 获取仓库
        getckNameList(){
            return this.$api.getCkNamesBy(  ).then(res =>{
               this.ckNameList = res
               // 赋值查询条件
                this.wmsWarehouseForm.ckName = this.ckNameList[0]
            })
        },
        // 获取客户信息
        getCompanyList(){
            this.$api.getCompanyList(  ).then(res =>{
                this.customerList = res.tableData
            })
        },
        // 获取保税属性
        getIsBonded(){
            this.$api.getDicList( { value:'Wms保税属性'} ).then(res =>{
                this.bondedTypeList = res
            })
        },
        // 搜索司机-车牌
        truckNoRemoteMethod(value){
            this.$api.wmsGetCarInfo( value ).then(res =>{
                this.driverTruckNoList = res
            })
        },
        // 输入
        selectTruckNo(e){
            this.wmsWarehouseForm.truckNo = e.target.value
        },
        // 创建日期获取
        getCreateDate(data){
            if(data === null){
                this.wmsWarehouseForm.createDateStart = ''
                this.wmsWarehouseForm.createDateEnd = ''
            }else{
                this.wmsWarehouseForm.createDateStart = data[0]
                this.wmsWarehouseForm.createDateEnd = data[1]
            }
        },
        // 计划作业日期获取
        getPlanDate(data){
            if(data === null){
                this.wmsWarehouseForm.planDateStart = ''
                this.wmsWarehouseForm.planDateEnd = ''
            }else{
                this.wmsWarehouseForm.planDateStart = data[0]
                this.wmsWarehouseForm.planDateEnd = data[1]
            }
        },
        // 表头搜索页码置为1
        taskListSeacher(){
            this.pagination.currentPage = 1
            this.getTaskList()
        },
        // 获取入库任务单列表
        getTaskList(){
            const { createDate,planDate, ...rest } = this.wmsWarehouseForm;
            const params = Object.keys(rest).reduce((acc, key) => {
                acc[key] = rest[key] === '' ? null : rest[key]; // 所有空字符串转 null
                return acc;
            }, {});            
            this.$api.getWMSTaskList( this.pagination.pageSize,this.pagination.currentPage,params ).then(res =>{
                this.taskList = res.tableData
                this.columns = res.columns
                this.pagination.total = res.total
                this.pagination.currentPage = res.current
                this.pagination.pageSize = res.size
            })
        },
        // 复制任务单
        copyInWarehouse(row){
            this.$api.wmsCopyTask( row.id ).then(res =>{
                this.getTaskList()
            })
        },
        // 新建入库任务单
        nweInWarehouse(){
            jumpInWarehouse(this, localStorage.getItem('token'), localStorage.getItem('name'), 'add', 'in')
            // this.jumpInWarehouse(localStorage.getItem('token'),localStorage.getItem('name'),'add','in')
        },
        // 新建出库任务单
        nweoutbound(){
            // this.jumpInWarehouse(localStorage.getItem('token'),localStorage.getItem('name'),'add','out')
            jumpInWarehouse(this, localStorage.getItem('token'), localStorage.getItem('name'), 'add', 'out')
        },
        //查看任务详情
        getdetails(row){
            // if(row.taskType === '出库'){
            //     this.jumpInWarehouse(localStorage.getItem('token'),localStorage.getItem('name'),row.id,'out')
            // }else{
            //     this.jumpInWarehouse(localStorage.getItem('token'),localStorage.getItem('name'),row.id,'in')
            // }
            if(row.taskType === '出库'){
                jumpInWarehouse(this, localStorage.getItem('token'), localStorage.getItem('name'), row.id, 'out')
            }else{
                jumpInWarehouse(this, localStorage.getItem('token'), localStorage.getItem('name'), row.id, 'in')
            }
        },
        // 双击列查看详情
        getdetailsDblclick({ row, column }){
            // this.jumpInWarehouse(localStorage.getItem('token'),localStorage.getItem('name'),row.id)
            if(row.taskType === '出库'){
                jumpInWarehouse(this, localStorage.getItem('token'), localStorage.getItem('name'), row.id, 'out')
            }else{
                jumpInWarehouse(this, localStorage.getItem('token'), localStorage.getItem('name'), row.id, 'in')
            }
        },
        // 合计表格表尾
        footerMethod({ columns, data }) {
            // 定义需要显示合计的字段
            const sumFields = ['qty1Sum','netWeight'];
            
            // 计算合计值
            const sums = {};
            sumFields.forEach(field => {
                sums[field] = data.reduce((acc, row) => {
                return acc + (Number(row[field]) || 0);
                }, 0);
            });
      
            return [
                columns.map((column, columnIndex) => {
                    const { field } = column;
                
                    // 第一列显示"合计"
                    if (columnIndex === 0) {
                        return '合计';
                    }
                
                    // 如果字段需要合计，显示合计值
                    if (sumFields.includes(field)) {
                        return this.formatNumber({ cellValue: sums[field] });
                    }
                
                    // 其他列显示"-"
                    return '-';
                })
            ];
        },
        formatNumber({ cellValue }) {
            // 1. 处理空值
            if (cellValue == null || cellValue === '') return '';
             // 2. 尝试转换为数字
            const num = Number(cellValue);
            // 3. 检查转换是否成功
            if (isNaN(num)) return cellValue;
            // 4. 使用国际化 API 格式化数字
            return num.toLocaleString('en-US', {
                minimumFractionDigits: 2, // 最少保留2位小数
                maximumFractionDigits: 2// 最多保留2位小数
            });
        },
        handleBeforeUnload() {
            closeAllWarehouseWindows()
        },
    },
    beforeDestroy(){
        closeAllWarehouseWindows()
    },
}
</script>
<style style lang="less" scoped>
.el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
    margin-bottom: 5px;
}
.flexBox{
    display: flex;
    align-items: flex-end;
}
// 任务单号样式
.el-link{
    font-size: 12px;
}
.truck-no-cell{
    display: inline-block;
    width: 100%;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    word-break: break-word;
    line-height: 1.2em;
}
</style>